
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import fname from '@/utils/string'
import { badgeSchemas } from '@/entities/scorecard'
import { VPopover } from 'v-tooltip'

@Component<BadgePicker>({
    components: { VPopover },
    filters: { fname },
})
export default class BadgePicker extends Vue {
    @Prop(String) public badge!: string
    @Prop({ type: Boolean, default: false }) public disabled!: boolean

    @Prop({ default: 20 })
    public width!: number

    private mounted() {
        if (!this.getBadgeSchema(this.badge)) {
            // if couldn't find badge in predefined schema, clear it
            this.$emit('change', '')
        }
    }

    get triggerStyle() {
        return `width: ${this.width * 1.7}px; height: ${this.width}px;`
    }

    public get badgeSchemas() {
        return badgeSchemas
    }

    public get badges() {
        return Object.keys(badgeSchemas)
    }

    public getBadgeSchema(badge) {
        return badgeSchemas[badge]
    }

    public get hasBadge() {
        return this.badge && badgeSchemas[this.badge]
    }
}
